import React, { useState } from "react";
import { Button, Container, Offcanvas } from "react-bootstrap";
import { FilterSearch } from "./";

interface ISFilterSidebar {
    title: string;
    morePartsDataFilters: Array<{ name: string; data: string[] }>;
    filterMoreParts: never[];
    setFilter: (filter: any, page?: number) => Promise<void>;
    isLoading: boolean;
    border?: boolean;
    mt?: number | string;
}

export const FilterSidebar: React.FC<ISFilterSidebar> = ({ title, morePartsDataFilters, filterMoreParts, setFilter, isLoading }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <Container fluid className="d-grid gap-2 mt-4">
            <Button variant="outline-dark" onClick={handleShow}>
                {title}
            </Button>
            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Body>
                    <FilterSearch
                        border={false}
                        data={morePartsDataFilters}
                        filterStore={filterMoreParts}
                        onFilter={setFilter}
                        isLoading={isLoading}
                    />
                    <Button variant="primary" onClick={handleClose}>
                        {title}
                    </Button>
                </Offcanvas.Body>
            </Offcanvas>
        </Container>
    )
}